import React, { Component } from 'react';
import { Segment, Modal } from 'semantic-ui-react';
import ReactTable from 'react-table';
class ListAccounts extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showPayment: false,
            data: {},
        };
    }

    render() {
        const { accounts } = this.props;
        return (
            <Modal size="small" open={this.props.open} onClose={this.props.close} closeIcon>
                <Modal.Header>Click on a row below to select an account:</Modal.Header>
                <Modal.Content>
                    <Segment.Group>
                        <Segment>
                            <ReactTable noDataText={null} minRows={0} defaultPageSize={this.props.reactTable().pageSize} showPagination={accounts.length > this.props.reactTable().pageSize ? true : false} filterable defaultFilterMethod={this.props._customFilter} className="celled -striped -highlight "
                                data={accounts}
                                getNoDataProps={() => {
                                    return { style: { display: 'none' } };
                                }}
                                getTrProps={(state, rowInfo) => {
                                    return {
                                        onClick: (e) => {
                                            this.props.showPaymentInterface(rowInfo.original.acoAccountId);
                                        },
                                        style: {
                                            cursor: "pointer",
                                            color: "#1e70bf"
                                        }
                                    }
                                }}
                                columns={[{
                                    Header: this.props.t("client.account"),
                                    accessor: 'acoInvoiceId',
                                    width: 120,
                                }, {
                                    Header: this.props.t("our.account"),
                                    accessor: 'acoAccountId',
                                    style: {
                                        textAlign: "right"
                                    },
                                    width: 100,
                                }, {
                                    Header: 'Name',
                                    id: 'conLastName',
                                    accessor: row => (
                                        row.conFirstName + " " + row.conLastName
                                    )
                                }, {
                                    Header: 'SSN',
                                    id: 'conSsn',
                                    style: {
                                        textAlign: "right"
                                    },
                                    width: 100,
                                    accessor: row => (
                                        row.conSsn ? this.props._padString(row.conSsn.toString()) : ""
                                    )
                                },{
                                    Header: 'Currency Code',
                                    id: 'acoIsoCode',
                                    accessor: row => (
                                        row.acoIsoCode
                                    )
                                }, {
                                    Header: 'AR',
                                    id: 'acoAmountReferred',
                                    width: 100,
                                    style: {
                                        textAlign: "right"
                                    },
                                    accessor: row => (
                                        (row.acoAmountReferred) ? this.props._currencyFormat(row.acoAmountReferred) : 0.00
                                    )
                                }]}
                            />
                        </Segment>
                    </Segment.Group>
                </Modal.Content>
            </Modal>
        );
    }
}
export default ListAccounts;


// WEBPACK FOOTER //
// ./src/app/ui/payments/ListAccounts.js